<script>
export default {
  props: {
    src: String,
  },
  data() {
    return {
      loading: true,
      pdf: {
        pdfjsLib: window['pdfjs-dist/build/pdf'],
        pdfDoc: null,
        pageNum: 1,
        pageRendering: false,
        pageNumPending: null,
      }
    }
  },
  computed: {
    pageCount() {
      return this.pdf.pdfDoc.numPages || 0;
    },
    currentPage() {
      return this.pdf.pageNum || 0;
    }
  },
  mounted() {
    this.pdf.canvas = this.$refs.canvas;
    this.pdf.ctx = this.pdf.canvas.getContext('2d');
    this.pdf.pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

    this.pdf.pdfjsLib.getDocument(this.src).promise.then((pdfDoc) => {
      this.pdf.pdfDoc = pdfDoc;
      this.renderPage(this.pdf.pageNum);
      this.loading = false;
    });
  },
  methods: {
    renderPage(num) {
      this.pdf.pageRendering = true;

      this.pdf.pdfDoc.getPage(num).then((page) => {
        const viewport = page.getViewport({scale: 1});
        this.pdf.canvas.height = viewport.height;
        this.pdf.canvas.width = viewport.width;

        const renderContext = {
          canvasContext: this.pdf.ctx,
          viewport: viewport
        };

        const renderTask = page.render(renderContext);

        renderTask.promise.then(() => {
          this.pdf.pageRendering = false;

          if (this.pdf.pageNumPending !== null) {
            this.renderPage(this.pdf.pageNumPending);
            this.pdf.pageNumPending = null;
          }
        });
      });

      this.pdf.pageNum = num;
    },
    queueRenderPage() {
      if (this.pdf.pageRendering) {
        this.pdf.pageNumPending = this.pdf.pageNum;
      } else {
        this.renderPage(this.pdf.pageNum);
      }
    },
    prevPage() {
      if (this.pdf.pageNum <= 1) {
        return;
      }

      this.pdf.pageNum--;
      this.queueRenderPage();
    },
    nextPage() {
      if (this.pdf.pageNum >= this.pdf.pdfDoc.numPages) {
        return;
      }

      this.pdf.pageNum++;
      this.queueRenderPage();
    },
  }
}
</script>

<template>
  <div class="m-b-n">
    <div v-show="loading">
      <span>Loading PDF</span>
      <i class="fa fa-cog fa-spin"></i>
    </div>
    <div v-show="!loading">
      <div class="m-b" v-if="!loading">
        <button class="btn btn-primary btn-xs" @click="prevPage" :disabled="currentPage == 1">&lt;</button>
        <span class="label label-default m">{{ currentPage }} / {{ pageCount }}</span>
        <button class="btn btn-primary btn-xs" @click="nextPage" :disabled="currentPage === pageCount">&gt;</button>
      </div>
      <canvas ref="canvas" class="full-width"></canvas>
    </div>
  </div>
</template>
